import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * We need to bound child logger, as an example full-screen-modal logger, with parent,
 * desktop, logger, so we taking original component id for creation of namespace
 */
const INTERACTIONS_STATE = 'interactions-state';
const REQUEST_INTERACTIONS_STATE = `get-${INTERACTIONS_STATE}`;
const PUBLISH_INTERACTIONS_STATE = `publish-${INTERACTIONS_STATE}`;
export class InteractionsState {
  constructor(_ref) {
    let {
      compId,
      pubSub
    } = _ref;
    _defineProperty(this, "pubSub", void 0);
    _defineProperty(this, "publishInteractionsAction", void 0);
    _defineProperty(this, "requestInteractionsAction", void 0);
    _defineProperty(this, "promise", Promise.resolve());
    _defineProperty(this, "state", {});
    _defineProperty(this, "saveInteractions", _ref2 => {
      let {
        data
      } = _ref2;
      this.state = data;
    });
    _defineProperty(this, "publishInteractions", () => {
      this.pubSub.publish(this.publishInteractionsAction, this.state);
      this.state = {};
    });
    _defineProperty(this, "requestInteractions", () => {
      this.promise = new Promise(resolve => {
        this.pubSub.subscribe(this.publishInteractionsAction, event => {
          this.saveInteractions(event);
          resolve();
        });
      });
      this.pubSub.publish(this.requestInteractionsAction);
    });
    _defineProperty(this, "subscribeOnInteractionsRequest", () => {
      this.pubSub.subscribe(this.requestInteractionsAction, this.publishInteractions);
    });
    this.pubSub = pubSub;
    this.state = {};
    this.promise = Promise.resolve();
    this.publishInteractionsAction = `[${compId}] ${PUBLISH_INTERACTIONS_STATE}`;
    this.requestInteractionsAction = `[${compId}] ${REQUEST_INTERACTIONS_STATE}`;
  }
  fetch() {
    return this.promise;
  }
  has(interaction) {
    return this.state[interaction];
  }
  start(interaction) {
    this.state[interaction] = true;
  }
  complete(interaction) {
    this.state[interaction] = false;
  }
}
//# sourceMappingURL=interactions-state.js.map